import { useContext, createContext } from 'react';

import type { ERegionCode } from '@sureapp/platform-sdk';

type TRegionContextValue = {
  regionCode: ERegionCode;
};

export const RegionContext = createContext<TRegionContextValue>({
  // @ts-expect-error
  regionCode: '',
});

export function useRegion() {
  return useContext(RegionContext);
}
